var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(932 2283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M980,295a3,3,0,0,1-3-3V278a3,3,0,0,1,3-3h2v-1a1,1,0,1,1,2,0v1h6v-1a1,1,0,1,1,2,0v1h2a3,3,0,0,1,3,3v14a3,3,0,0,1-3,3Zm-1-3a1,1,0,0,0,1,1h14a1,1,0,0,0,1-1v-9H979Zm16-11v-3a1,1,0,0,0-1-1h-2v1a1,1,0,1,1-2,0v-1h-6v1a1,1,0,1,1-2,0v-1h-2a1,1,0,0,0-1,1v3Z",
    transform: "translate(-1904 -2552)",
    fill: "#809fb8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(-932 -2283)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.9d28b10ac148508fea6790b1399c98b2.svg";
export { ForwardRef as ReactComponent };